var irreducible = require('./irreducible');
var isType = require('./isType');

module.exports = irreducible('Type', isType);


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/Type.js
// module id = 6022
// module chunks = 0